export default __webpack_public_path__ + "static/media/Wood-And-Welds-Logomark.c765ed06.svg";